<template>
  <!-- //完成 -->
  <div class="main home">
    <van-nav-bar
      :title="newsContent.title"
      left-arrow
      @click-left="$router.go(-1)"
      placeholder
      fixed
      safe-area-inset-top
    />
    <van-cell-group></van-cell-group>
    <div>
      <div v-html="newsContent.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hello",
  components: {},
  data() {
    return {
      newsContent: {},
    };
  },
  computed: {},
  watch: {
    $route() {},
  },

  methods: {
    getContent(id, key) {
      this.$api.getUser.get_agreement({ id: id }).then((res) => {
        if (res.code == 200) {
          this[key] = res.result;
        } else {
          this.$toast.fail(res.result);
        }
      });
    },
  },
  created() {
    let m = this.$route.query.id;
    this.getContent(m, "newsContent");
  },
  computed: {},
  mounted() {},
};
</script>

<style lang="less">
html,
body {
  background-color: #fafafa;
}
.main {
  min-height: 100vh;
}
</style>
